module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-800.104feb7e.ttf";